<template>
	<v-btn :color="color" @click.stop="clicked()" :small="small" :outlined="outlined" :large="large" :block="large || block" :disabled="is_loading || disabled" :loading="loading">
		<span v-if="text">{{ text }}</span>
	</v-btn>
</template>

<script>
export default {
	data: () => ({}),
	props: {
		text: {
			type: String,
			default: null,
		},
		color: {
			type: String,
			default: "maingrey",
		},
		large: {
			type: Boolean,
			default: false,
		},
		disabled: {
			type: Boolean,
			default: false,
		},
		loading: {
			type: Boolean,
			default: false,
		},
		outlined: {
			type: Boolean,
			default: false,
		},
		small: {
			type: Boolean,
			default: false,
		},
		block: {
			type: Boolean,
			default: false,
		},
	},
	computed: {
		is_loading() {
			return this.$store.getters.is_loading;
		},
	},
	methods: {
		clicked() {
			this.$emit("click");
		},
	},
};
</script>
